import api from "../helpers/axios";

class FacilityService {
  /*
  Get a single facility's details by its ID (UUID).
  */
  async getFacilityById(facilityId) {
    try {
      const response = await api.get(`/facility/${facilityId}`);
      return response?.data;
    } catch (error) {
      console.error(`Error fetching facility with ID ${facilityId}:`, error);
      throw error;
    }
  }

  /*
  Get a single facility's details by its facility_number (not the UUID id).
  */
  async getFacilityByNumber(facilityNumber) {
    try {
      const response = await api.get(`/facility/by-number/${facilityNumber}`);
      return response?.data;
    } catch (error) {
      console.error(`Error fetching facility with facility_number ${facilityNumber}:`, error);
      throw error;
    }
  }

  /*
   Get all models assigned to the logged-in Facility Admin.
  */
  async getFacilityModelSettings() {
    try {
      const response = await api.get('/models/facility-settings');
      return response.data;
    } catch (error) {
      console.error(`Error fetching facility model settings:`, error);
      throw error;
    }
  }

  /*
   Calls the PUT /models/facility-settings/{facility_config_id} endpoint.
   * @param {string} facilityConfigId - The UUID of the 'facilitymodelconfig' record.
   * @param {object} settingsData - The data payload to send.
   * @param {boolean} settingsData.is_enabled_for_users
   * @param {boolean} settingsData.is_default_for_facility
   * @param {number|null} settingsData.facility_temperature_override
   * @param {number|null} settingsData.facility_max_tokens_override
  */
  async updateFacilityModelSettings(facilityConfigId, settingsData) {
    try {
      // Make sure we are only sending the fields the admin can control
      const payload = {
        is_enabled_for_users: settingsData.is_enabled_for_users,
        is_default_for_facility: settingsData.is_default_for_facility,
        facility_temperature_override: settingsData.facility_temperature_override,
        facility_max_tokens_override: settingsData.facility_max_tokens_override,
      };
      
      const response = await api.put(
        `/models/facility-settings/${facilityConfigId}`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error(`Error updating model settings for ID ${facilityConfigId}:`, error);
      throw error;
    }
  }

  async createFacility(facilityData) {
    try {
      const response = await api.post('/facility/', facilityData);
      return response.data;
    } catch (error) {
      console.error('Error creating facility:', error);
      throw error;
    }
  }

  async updateFacility(facilityId, facilityData) {
    try {
      const response = await api.patch(`/facility/${facilityId}`, facilityData);
      return response.data;
    } catch (error) {
      console.error(`Error updating facility with ID ${facilityId}:`, error);
      throw error;
    }
  }
}

export default new FacilityService();